'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' });

var ViewQuilt = function ViewQuilt(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ViewQuilt = (0, _pure2.default)(ViewQuilt);
ViewQuilt.muiName = 'SvgIcon';

exports.default = ViewQuilt;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ViewQuilt.js
// module id = 2993
// module chunks = 0